import React from "react";
import MainFooter from "./Homepage/components/MainFooter";
import { Link } from "react-router-dom";
import { setUserClickData } from "../utility/setUserClickData";
import FooterSection from "./HomePageNew/components/footer/footer";

const GodrejGrievance = () => {
  return (
    <div className="bg-black min-h-screen flex flex-col justify-between">
      <div className="container w-full h-full max-w-7xl mx-auto text-white px-3 sm:px-0 py-10">
        {/* Logo + Home */}
        <Link
          to={"/"}
          onClick={() => {
            setUserClickData({
              event_name: "link-to-home-page",
            });
          }}
        >
          <img
            className="pt-2"
            src="/assets/img/newLogo.png"
            alt="Digitmoney"
            width={160}
          />
        </Link>

        {/* Title Section */}
        <div className="pt-6">
          <h1 className="text-2xl md:text-3xl font-semibold text-green-400">
            Godrej Finance Limited
          </h1>
          <h2 className="mt-2 text-sm md:text-md font-semibold text-blue-300">
            Grievance Redressal Mechanism
          </h2>
        </div>

        {/* Content Cards */}
        <div className="mt-10  grid sm:grid-cols-2 gap-2 sm:gap-4">
          {/* Officer Details */}
          <div className="bg-gray-900/30 p-6 rounded-xl shadow-lg border-[1px] text-sm sm:text-lg border-gray-900">
            <h3 className="text-xl font-semibold text-white mb-3">
              1. Grievance Redressal Officer
            </h3>
            <p className="text-gray-300 leading-relaxed">
              <span className="font-medium text-white">Name:</span>Mr. Ankit Gupta
              <br />
              <span className="font-medium text-white">Email:</span>{" "}
              <a
                href="mailto:nodalofficer@godrejfinance.com"
                target="_blank"
                rel="noreferrer"
                className="text-green-400 font-medium text-sm sm:text-md hover:text-green-300 transition-colors"
              >
                nodalofficer@godrejfinance.com
              </a>
              <br />
              <span className="font-medium text-white">Contact No:</span>{" "}
              +91 8657764527
              <br />
              <span className="font-medium text-white">Address:</span> Godrej
              Finance Limited, 9th Floor, Godrej One, Pirojshanagar, Vikhroli
              East, Mumbai, 400079, Maharashtra, India
            </p>
          </div>

          {/* Grievance Link */}
          <div className="bg-gray-900/30 p-6 rounded-xl text-sm sm:text-lg shadow-lg border-[1px] border-gray-900">
            <h3 className="text-xl font-semibold text-white mb-3">
              2. Grievance Redressal Mechanism Link
            </h3>
            <a
              href="https://godrejfinance.com/gf/information-and-policies"
              target="_blank"
              rel="noreferrer"
              className="text-green-400 font-medium text-sm sm:text-md hover:text-green-300 transition-colors break-words"
            >
              https://godrejfinance.com/gf/information-and-policies
            </a>
            <p className="text-sm text-gray-400 mt-1">
              (Information and Policies &gt; Customer Information &gt; Grievance
              Redressal Mechanism)
            </p>
          </div>

          {/* Privacy Policy */}
          <div className="bg-gray-900/30 p-6 rounded-xl text-sm sm:text-lg shadow-lg border-[1px] border-gray-900">
            <h3 className="text-xl font-semibold text-white mb-3">
              3. Privacy Policy
            </h3>
            <p className="text-gray-300">
              Privacy Policy of Godrej Finance Limited can be found at:
            </p>
            <a
              href="https://godrejfinance.com/gf/information-and-policies"
              target="_blank"
              rel="noreferrer"
              className="text-green-400 font-medium text-sm sm:text-md hover:text-green-300 transition-colors break-words"
            >
              https://godrejfinance.com/gf/information-and-policies
            </a>
            <p className="text-sm text-gray-400 mt-1">
              (Information and Policies &gt; Policies &gt; Privacy Policy)
            </p>
          </div>

          {/* RBI Sachet */}
          <div className="bg-gray-900/30 p-6 rounded-xl text-sm sm:text-lg shadow-lg border-[1px] border-gray-900">
            <h3 className="text-xl font-semibold text-white mb-3">
              4. RBI Sachet Link
            </h3>
            <a
              href="https://sachet.rbi.org.in"
              target="_blank"
              rel="noreferrer"
              className="text-green-400 font-medium text-sm sm:text-md hover:text-green-300 transition-colors break-words"
            >
              https://sachet.rbi.org.in
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
     <FooterSection/>
    </div>
  );
};

export default GodrejGrievance;
